// extracted by mini-css-extract-plugin
module.exports = {"popup":"BudgetTable_popup__1FhF4","budget":"BudgetTable_budget__s_tnt","fadeIn":"BudgetTable_fadeIn__18tPk","fadeOut":"BudgetTable_fadeOut__2ro98"};